import type { Shell } from "../host/shell.js";
import { STORE_URL } from "../host/shell.js";

/**
 * The app shell is older than this release supports (P4-APP-08): a clear way forward instead of a
 * page that half works. Shown in place of the app, as the old-browser notice is (compat.js).
 */
export function UpdateApp({ shell }: { shell: Shell }) {
  return (
    <section class="landing age-gate update-app">
      <div class="card" role="alert" aria-labelledby="update-title">
        <h1 id="update-title">Please update the Obean app</h1>
        <p>
          This version of the app is too old for today's Obean. Update it from the store, then open
          it again: your name and progress stay as they are.
        </p>
        <a class="button" href={STORE_URL[shell.platform]}>
          Update in Google Play
        </a>
      </div>
    </section>
  );
}
